<template>
    <form @submit.prevent="submit">
        <modal width="small">
            <modal-header>Reklamation an Produzenten weiterleiten</modal-header>
            <modal-content>
                <form-datepicker id="complaint_at" label="Reklamationsdatum" name="complaint_at"
                                 v-model:date="form.complaint_at" :error="form.errors.complaint_at"/>

                <form-input id="amount" :label="'Stückzahl (max '+maxComplaintQty+' Stück)'" name="amount"
                            v-model="form.amount"
                            :error="form.errors.amount" autocomplete="off"/>

                <form-select id="complaint_reason_id" label="Reklamationsgrund" name="complaint_reason_id"
                             v-model="form.complaint_reason_id" :error="form.errors.complaint_reason_id"
                             :options="complaintReasonOptions" @change="updateEditor"/>

                <form-html id="text" label="Nachricht an Produzenten" v-model="form.text" :error="form.errors.text"
                           height="300px" ref="quill"/>

                <form-text id="comment" label="Kommentar" name="comment" v-model="form.comment"
                           :error="form.errors.comment" height="100px"/>

                <form-select id="creator" label="Ersteller" name="creator" v-model="form.creator"
                             :error="form.errors.creator" :options="creatorOptions"/>

                <form-select id="admin_user_id" label="Bearbeitet von" name="admin_user_id" v-model="form.admin_user_id"
                             :error="form.errors.admin_user_id" :options="adminUserOptions"/>

                <form-select id="reason_valid" label="Berechtigt" name="reason_valid" v-model="form.reason_valid"
                             :error="form.errors.reason_valid" :options="reasonValidOptions"/>

                <form-select id="producer_order_id" label="Produzentenauftrag" name="producer_order_id"
                             v-model="form.producer_order_id"
                             :error="form.errors.producer_order_id" :options="producerOrderOptions"/>

                <hr>

                <form-text id="result" label="Ergebnis der Reklamation" name="result" v-model="form.result"
                           :error="form.errors.result" height="100px" v-if="producerComplaint"/>

                <form-button type="button" @click="closeComplaint" v-if="producerComplaint" class="btn--block"
                             color="secondary" :disabled="complaintClosed">Reklamation schließen
                </form-button>

            </modal-content>
            <modal-actions @closeDialog="this.$emit('closeDialog')">
                <form-button type="submit" color="secondary" :disabled="complaintClosed || form.processing" :class="{'btn--processing': form.processing}">Speichern</form-button>
            </modal-actions>
        </modal>
    </form>
</template>

<script>
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormText from '@partfactory/Shared/Form/FormText';
import FormHtml from '@partfactory/Shared/Form/FormHtml';

export default {
    name: 'ProducerComplaintModal',
    components: {
        FormHtml,
        FormText,
        FormSelect, FormInput, FormDatepicker, FormButton, ModalActions, ModalContent, ModalHeader, Modal
    },
    emit: ['closeDialog'],
    props: {
        producerComplaint: Object,
        askForQuote: Object,
        forwardClientComplaint: Boolean,
        adminUsers: Object,
    },
    data() {
        let text = null;

        const currentDate = this.$moment(new Date, 'YYYY-MM-DD').format('YYYY-MM-DD');

        const form = useForm({
            complaint_at: this?.producerComplaint?.complaint_at ? this?.producerComplaint?.complaint_at : currentDate,
            amount: this?.producerComplaint?.amount ? this?.producerComplaint?.amount : null,
            comment: this?.producerComplaint?.comment ? this?.producerComplaint?.comment : null,
            complaint_reason_id: this?.producerComplaint?.complaint_reason_id ? String(this?.producerComplaint?.complaint_reason_id) : null,
            creator: this?.producerComplaint?.creator ? String(this?.producerComplaint?.creator) : String('1'),
            admin_user_id: this?.producerComplaint?.admin_user_id ? this?.producerComplaint?.admin_user_id : this.$page.props.user.id,
            reason_valid: this?.producerComplaint?.reason_valid ? String(this?.producerComplaint?.reason_valid) : String('-1'),
            producer_order_id: this?.producerComplaint?.producer_order_id ? this?.producerComplaint?.producer_order_id : this.askForQuote.producer_order.id,
            text: '<p>Bitte Reklamationsgrund aktualisieren um Nachricht zu laden.</p>',
            closed: null,
            result: this?.producerComplaint?.result ? this?.producerComplaint?.result : null,
        });

        return {form, text};
    },
    computed: {
        complaintReasonOptions() {
            return this.$page.props.complaintReasons;
        },
        creatorOptions() {
            // Todo: Config
            return [
                {value: 1, text: 'Partfactory'},
                {value: 0, text: 'Kunde'},
            ];
        },
        reasonValidOptions() {
            // Todo: Config
            return [
                {value: -1, text: 'offen'},
                {value: 0, text: 'Nein'},
                {value: 1, text: 'Ja'},
            ];
        },
        adminUserOptions() {
            let adminUserOptions = [];
            this.adminUsers?.forEach(adminUser => {
                adminUserOptions.push({value: adminUser.id, text: adminUser.name});
            });

            return adminUserOptions;
        },
        producerOrderOptions() {
            return [
                {value: this.askForQuote.producer_order.id, text: this.askForQuote.pfnumber},
            ];
        },
        maxComplaintQty() {
            let maxComplaintQty = 0;

            if (this.askForQuote?.client_complaints.length > 0) {
                this.askForQuote?.client_complaints?.forEach((complaint) => {
                    maxComplaintQty += complaint.amount;
                });

                this.askForQuote?.producer_complaint?.forEach((outgoing) => {
                    maxComplaintQty += outgoing.amount;
                });
            } else {
                this.askForQuote?.incoming_goods_producer?.forEach((complaint) => {
                    maxComplaintQty += complaint.amount;
                });

                this.askForQuote?.outgoing_goods_client?.forEach((outgoing) => {
                    maxComplaintQty -= outgoing.amount;
                });

            }

            return maxComplaintQty;
        },
        complaintClosed() {
            return this?.producerComplaint?.closed;
        },
    },
    methods: {
        updateEditor() {
            const reason = this.$page.props.complaintReasons.filter(reason => {
                return reason.value === String(this?.form?.complaint_reason_id);
            });

            const reasonString = reason?.[0]?.text ? reason?.[0]?.text : 'Bitte auswählen';

            if (this.askForQuote?.producer_order?.producer_user?.language === 2) {
                this.$language.current = 'en';
            }

            const translated = this.$gettext('<h1>Guten Tag %{name},</h1>' +
                '<p>leider müssen wir Ihnen mitteilen, dass die Ware aus dem Auftrag <strong>%{pfnumber}</strong> reklamiert wurde. Grund der Reklamation ist: <strong>%{reason}</strong>.</p>' +
                '<p>Wir prüfen diesen Sachverhalt und melden uns mit dem Ergebnis der Prüfung umgehend bei Ihnen.</p>' +
                '<p>Beste Grüße</p><p>%{admin}, Service Operator PART FACTORY</p>');

            this.text = this.$gettextInterpolate(translated, {
                name: this.askForQuote?.producer_order?.producer_user?.name,
                pfnumber: this.askForQuote.pfnumber,
                orderUrl: this.$page.props.urls.producer_url + '/order/' + this.askForQuote?.producer_order?.id,
                reason: reasonString,
                admin: this.$page.props.user.name,
            });

            this.$language.current = 'de';

            this.$refs.quill.updateEditor(this.text);
        },
        submit() {
            if (!this.forwardClientComplaint && this.producerComplaint?.id) {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                        text: this.text,
                    }))
                    .patch(this.$$route('ask-for-quote.order-information.producer-complaint.patch', {
                        'askForQuote': this.askForQuote.id,
                        'producerComplaint': this.producerComplaint.id
                    }), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            } else {
                this.form
                    .transform(data => ({
                        ...data,
                        _token: this.$page.props.csrf_token,
                        text: this.text,
                    }))
                    .post(this.$$route('ask-for-quote.order-information.producer-complaint', {'askForQuote': this.askForQuote.id}), {
                        onSuccess: () => this.$emit('closeDialog'),
                    });
            }
        },
        closeComplaint() {
            this.form.closed = true;
            this.submit();
        },
    },
};
</script>
